import React from 'react';
import classNames from 'classnames';

import { useOverviewPageStyles } from './style/overview-page-style';
// TODO: [yaoyao] when we show new overview page in multiple places, we need to dynamically decide which page to use
import { StyledPerformanceMaxSingleCampaign } from './pmax-single-campaign-page/pmax-single-campaign';

export const OverviewPage = (props) => {
  const styles = useOverviewPageStyles();

  return (
    <div className={classNames(['ba-overview-page', styles.pageContainer])}>
      <StyledPerformanceMaxSingleCampaign {...props} />
    </div>
  );
};

OverviewPage.propTypes = {
};

OverviewPage.defaultProps = {
};

